<footer class="section footer-area">
    <section id="contact" class="contact-area ptb_100" *ngIf="currentPage !== 'services'">
        <app-contact-form></app-contact-form>
    </section>
    <!-- Footer Bottom -->
    <div class="footer-bottom bg-grey">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <!-- Copyright Area -->
                    <div class="copyright-area d-flex flex-wrap justify-content-center justify-content-sm-between text-center py-4">
                        <!-- Copyright Left -->
                        <div class="copyright-left">&copy; Copyrights 2022 Avanta Marketing All rights reserved.</div>
                        <div class="copyright-right">
                            <ul class="social-icons list-inline">
                                <li class="list-inline-item px-1"><a href="#"><i class="fab fa-facebook"></i></a></li>
                                <li class="list-inline-item px-1"><a href="#"><i class="fab fa-instagram"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>